import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43dab184"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "queues-list-item_queue" }
const _hoisted_2 = { class: "queues-list-item_namespace" }
const _hoisted_3 = {
  key: 0,
  class: "queues-list-item_remove"
}
const _hoisted_4 = { class: "queues-list-item__confirm-popover" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "queues-list-item__confirm-popover-message" }, " Открепить очередь? ", -1))
const _hoisted_6 = { class: "queues-list-item__confirm-popover-buttons" }

import { computed, PropType, ref } from 'vue';
import { QueueRelationModel } from '@/components/task-forms/models';
import { ListBulletIcon, TrashIcon } from 'tir-style-system/icons/outline';
import { TirPmSvg, TirPmButton, TirPmButtonVariantEnum, TirPmButtonSizeEnum } from 'tir-components';
import { TirPmPopover } from 'tir-components';
import { onMounted } from 'vue';
import { RouterLink, useRouter } from 'vue-router';

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'queues-list-item',
  props: {
  /**id проекта */
  projectId: { type: Number, required: true },
  /**Очередь задачи */
  queue: { type: Object as PropType<QueueRelationModel> },
  editing: { type: Boolean, default: true },
},
  emits: ["remove"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;


/**События */


/**Ссылка на компонент поповера */
const $confirmPopover = ref<InstanceType<typeof TirPmPopover>>();

const router = useRouter();

/**Ссылка на DOM */
const $queue = ref<HTMLElement>();

/**Открепить очередь */
const removeQueue = () => {
  emit('remove', props.queue.Id);
  $confirmPopover.value?.close();
};

/**Перейти в очередь */
const computedRoute = computed(() => {
  return router.resolve({
    name: 'queue',
    params: {
      projectId: props.projectId,
      namespaceId: props.queue.Namespace.Id,
      queueId: props.queue.Id,
    },
  });
});

__expose({
  queueItem: $queue,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RouterLink), {
    ref_key: "$queue",
    ref: $queue,
    class: "queues-list-item",
    to: computedRoute.value,
    onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["middle","prevent"]))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ListBulletIcon)),
        _createTextVNode(" " + _toDisplayString(__props.queue.Name), 1)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(TirPmSvg), {
          url: __props.queue.Namespace.Icon,
          class: "queues-list-item_namespace-icon",
          color: __props.queue.Namespace.Color
        }, null, 8, ["url", "color"]),
        _createTextVNode(" " + _toDisplayString(__props.queue.Namespace.Name), 1)
      ]),
      (__props.editing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(TirPmPopover), {
              ref_key: "$confirmPopover",
              ref: $confirmPopover,
              "custom-position": {
          right: '0rem',
          bottom: '0.25rem',
        },
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop","prevent"]))
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(TirPmButton), {
                      variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                      size: _unref(TirPmButtonSizeEnum).Small,
                      onClick: _withModifiers(removeQueue, ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Открепить ")
                      ]),
                      _: 1
                    }, 8, ["variant", "size", "onClick"]),
                    _createVNode(_unref(TirPmButton), {
                      variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                      size: _unref(TirPmButtonSizeEnum).Small,
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($confirmPopover.value?.close()), ["stop"]))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Отмена ")
                      ]),
                      _: 1
                    }, 8, ["variant", "size"])
                  ])
                ])
              ]),
              default: _withCtx(() => [
                (__props.editing)
                  ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                      key: 0,
                      variant: _unref(TirPmButtonVariantEnum).LinkState,
                      size: _unref(TirPmButtonSizeEnum).Small
                    }, {
                      leftSlot: _withCtx(() => [
                        _createVNode(_unref(TrashIcon))
                      ]),
                      _: 1
                    }, 8, ["variant", "size"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 512)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})